export const STORE_SIGN_IN_INFO = 'STORE_SIGN_IN_INFO';
export const UPDATE_DOT = 'UPDATE_DOT';
export const UPDATE_DOT_WITH_HIGH_LOW = 'UPDATE_DOT_WITH_HIGH_LOW';
export const UPDATE_DOT_SIGNLE_LINE_WITH_HIGH_LOW =
  'UPDATE_DOT_SIGNLE_LINE_WITH_HIGH_LOW';
export const UPDATE_DATE = 'UPDATE_DATE';
